import { Component, OnInit, forwardRef } from '@angular/core';
import { 
	ControlValueAccessor,
	NG_VALUE_ACCESSOR, NG_VALIDATORS, 
	FormGroup,FormControl, 
	Validator, Validators,AbstractControl, ValidationErrors 
} from "@angular/forms";

@Component({
  selector: 'prgov-sub-form',
  templateUrl: './sub-form.component.html',
  styleUrls: ['./sub-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SubFormComponent),
      multi: true
    },
     {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SubFormComponent),
      multi: true
    }
  ]  
})
export class SubFormComponent implements OnInit, ControlValueAccessor, Validator {
	public addressForm: FormGroup = new FormGroup({
		addressLine: new FormControl("",[Validators.required]),
		areacode: new FormControl('', [Validators.required, Validators.maxLength(5)])
	});

	constructor() { }

	ngOnInit() {
	}

	public onTouched: () => void = () => {};

	writeValue(val: any): void {
		val && this.addressForm.setValue(val, { emitEvent: false });
	}

	registerOnChange(fn: any): void {
		console.log("on change");
		this.addressForm.valueChanges.subscribe(fn);
	}

	registerOnTouched(fn: any): void {
		console.log("on blur");
		this.onTouched = fn;
	}

	setDisabledState?(isDisabled: boolean): void {
		isDisabled ? this.addressForm.disable() : this.addressForm.enable();
	}

	validate(c: AbstractControl): ValidationErrors | null{
		console.log("ADress validation");
		return this.addressForm.valid ? null : { invalidForm: {valid: false, message: "Address fields are invalid"}};
	}
}
